import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  PageActions,
  Link,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import Select2 from "react-select";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
const AddCourseSubscriber = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [user, setUser] = useState("");
  const handleSelectChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const [userError, setUserError] = useState("");
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseUsers = [];
    try {
      responseUsers = await axios.get(`/users?per_page=10000`);
      setOptionsUsers(
        responseUsers.data.data.data.map((item, index) => {
          return {
            label: item?.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <Page
      title="Add User"
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/subscribers`),
      }}
    >
      <Card>
        {isSaving ? <Loading /> : null}

        <FormLayout>
          <Text>User</Text>
          <Select2
            options={optionsUsers}
            onChange={handleSelectChangeUser}
            value={user}
            placeholder="Please select a user"
            styles={{
              menu: (provided) => ({
                ...provided,
                maxHeight: "170px",
                overflowY: "auto",
              }),
              menuList: (provided) => ({
                ...provided,
                maxHeight: "170px",
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPosition="absolute"
          />
          <InlineError message={userError} />
          <div style={{ height: "200px" }}></div>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
      />
    </Page>
  );
  function handleSave() {
    if (user === "") {
      setUserError("Please select a user");
    } else {
      setIsSaving(true);
      axios
        .post(`/orders/courses/${id}`, { user_id: user.value })
        .then((result) => {
          navigate(`/admin/courses/${id}/subscribers`);
        })
        .catch((err) => console.log(err));
    }
  }
};

export default AddCourseSubscriber;
